import React from 'react'
import PropTypes from 'prop-types'

function Triangle({borderColor = 'transparent', triangleColor = 'white'}) {
  return (
    <svg height="8" width="16" className="triangle">
      <line x1="8" y1="0" x2="1" y2="7" stroke={borderColor} />
      <line x1="8" y1="0" x2="15" y2="7" stroke={borderColor} />
      <polygon points="8,1 0,8 16,8" stroke="none" fill={triangleColor} />
    </svg>
  )
}

Triangle.propTypes = {
  borderColor: PropTypes.string,
  triangleColor: PropTypes.string,
}

export default Triangle
